/**
 * Returns the currently logged in user if using an SCA with the AlchemySigner
 * or the connected EOA details.
 *
 * @example
 * ```ts
 * import { getUser } from "@account-kit/core";
 * import { config } from "./config";
 *
 * const user = getUser(config);
 * ```
 *
 * @param {AlchemyAccountsConfig} config the account config containing app state
 * @returns {GetUserResult} the user if the signer or an EOA are connected
 */
export const getUser = (config) => {
    const user = config.store.getState().user;
    if (user == null)
        return user ?? null;
    // @ts-ignore
    user.type = "sca";
    // @ts-ignore
    return user;
};
//# sourceMappingURL=getUser.js.map